import { onUserToClientActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { UserForInternalActivityCard } from "./UserForInternalActivityCard";

interface Props {
  userToClientId: number
  config: server.dto.ActivityPanelConfig
}

export const UserForInternalActivityPanel = (props: Props) => {
  return <ActivityPanel<server.dto.UserToClientActivity>
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.UserForInternalAdmin.ListActivity({ itemId: props.userToClientId, page, perPage })}
    renderActivity={(activity => <UserForInternalActivityCard key={activity.activityId} activity={activity} />)}
    onActivityRegisterFn={onUserToClientActivity}
    onActivity={(activity) => {
      if (activity.itemId !== props.userToClientId) return { refreshActivities: false };

      const iAmActor = (activity.actor?.userId === site.currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}